import type { SubscriberFeedbackLocale } from "@/locales/fr/subscriber-feedback";

import { EAbusiveReportType } from "@/types/backoffice/dto/subscriber-feedback/abusive-report-type.ts";
import { ESubscriberFeedbackFormType } from "@/types/backoffice/dto/subscriber-feedback/subscriber-feedback-allowed-form-dto.ts";
import { EInstallSatisfactionApplianceInstalledDto } from "@/types/backoffice/dto/survey/install-satisfaction/install-satisfaction-appliance-installed-dto.ts";

const subscriberFeedbackLocale: SubscriberFeedbackLocale = {
  subscriberFeedback: {
    title: "Subscriber Feedback",
    subject: "Subject",
    types: {
      [ESubscriberFeedbackFormType.ABUSE_REPORT]: "Abuse Report",
      [ESubscriberFeedbackFormType.INSTALL_SATISFACTION]: "Install Satisfaction",
    },
    abuse: {
      confirm: "Confirm abuse",
      type: "Person targeted by the report",
      appointment: "Appointment date",
      reason: "Reason",
      abusiveReportType: {
        [EAbusiveReportType.INTERVENTION]: "Technician",
        [EAbusiveReportType.VISIT]: "Door to door operator",
      },
    },
    installSatisfaction: {
      punctuality: "Punctuality",
      cleanliness: "Cleanliness of the installation",
      explanations: "Explanation of the solution",
      friendliness: "Technician's friendliness",
      professionalism: "Professionalism",
      rateTableHelp: "1: Unsatisfied / 2: Not satisfied / 3: Moderately satisfied / 4: Satisfied / 5: Very satisfied",
      intervention: "Intervention date",
      applianceInstalledLabel: "Have all your heating appliances (radiators and towel dryers) been fully equipped?",
      applianceInstalled: {
        [EInstallSatisfactionApplianceInstalledDto.TOTALLY]: "Fully equipped",
        [EInstallSatisfactionApplianceInstalledDto.PARTIALLY_REQUESTED_BY_SUBSCRIBER]:
          "Partially, at the subscriber's request",
        [EInstallSatisfactionApplianceInstalledDto.PARTIALLY_BY_TECHNICIAN]:
          "Partially, the technician should have connected them",
      },
      subscriberRecommendsSolutionLabel:
        "Based on your current experience, from the appointment scheduling to the solution installation, would you recommend the Voltalis solution to others ?",
      notPronounced: "No comment",
      doNotRecommend: "I would not recommend the Voltalis solution at all",
      recommend: "I would recommend the Voltalis solution without hesitation",
      commentLabel:
        "Do you have any particular comment about your installation to share with us ? If not all heating appliances were equipped, why ?",
    },
  },
};

export default subscriberFeedbackLocale;
